// src/pages/micuenta/PublicarEmpleo.jsx
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { FaArrowLeft } from "react-icons/fa";
import "./publicarempleo.css";

function PublicarEmpleo() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!user || user.userType !== "employer") {
    return (
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Acceso denegado</h2>
          <p>Debes ser empleador para publicar un empleo.</p>
        </div>
      </div>
    );
  }

  // --- Campos principales de la oferta ---
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [requirements, setRequirements] = useState("");
  const [benefits, setBenefits] = useState("");

  // --- Selecciones obligatorias ---
  const [modality, setModality] = useState("");
  const [workLanguage, setWorkLanguage] = useState("");
  const [visaRequirement, setVisaRequirement] = useState("");
  const [jobType, setJobType] = useState("");

  // --- Categorías y Subcategorías ---
  const categories = {
    "Administración": ["Contabilidad", "Recursos Humanos", "Administración de Empresas"],
    "Tecnología": ["Desarrollo de Software", "Soporte Técnico", "Redes", "Ciberseguridad"],
    "Salud": ["Enfermería", "Medicina", "Terapia Física"],
    "Comercio": ["Ventas", "Marketing", "Atención al Cliente"],
    "Construcción": ["Arquitectura", "Ingeniería Civil", "Obras"],
    "Educación": ["Docencia", "Administración Educativa"],
    "Hostelería": ["Cocina", "Servicio al Cliente", "Gestión Hotelera"],
    "Transporte": ["Conducción", "Logística", "Mantenimiento"],
    "Servicios": ["Limpieza", "Mantenimiento", "Consultoría"]
  };
  const [category, setCategory] = useState("");
  const [subcategory, setSubcategory] = useState("");

  // --- Selección de Estado y Ciudad ---
  const [stateUS, setStateUS] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const statesUS = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
    "Connecticut", "Delaware", "Florida", "Georgia", "Hawái", "Idaho",
    "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Luisiana",
    "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Misisipi",
    "Misuri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
    "New Mexico", "New York", "Carolina del Norte", "Dakota del Norte",
    "Ohio", "Oklahoma", "Oregón", "Pensilvania", "Carolina del Sur",
    "Dakota del Sur", "Tennessee", "Texas", "Utah", "Vermont", "Virginia",
    "Washington", "Virginia Occidental", "Wisconsin", "Wyoming"
  ];

  // --- Salario y destacar empleo ---
  const [salary, setSalary] = useState("");
  const [highlight, setHighlight] = useState(false);

  // --- Campos opcionales de contacto ---
  const [phone, setPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");

  // Función para reiniciar subcategoría al cambiar la categoría
  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
    setSubcategory("");
  };

  // Función para reiniciar ciudad al cambiar el estado
  const handleStateChange = (e) => {
    setStateUS(e.target.value);
  };

  // Función para crear el objeto de empleo
  const createJobObject = (statusValue) => {
    return {
      id: Date.now(),
      title,
      description,
      requirements,
      benefits,
      modality,
      workLanguage,
      visaRequirement,
      jobType,
      category,
      subcategory,
      stateUS,
      city,
      zipCode,
      salary,
      highlight,
      phone,
      contactEmail,
      status: statusValue, // "Borrador" o "Publicado"
      employerId: user.id,
      datePosted: new Date().toLocaleDateString(),
    };
  };

  // Validación de campos obligatorios
  const allRequiredFilled = () => {
    return (
      title &&
      description &&
      requirements &&
      benefits &&
      modality &&
      workLanguage &&
      visaRequirement &&
      jobType &&
      salary &&
      category &&
      subcategory &&
      stateUS &&
      zipCode &&
      city
    );
  };

  const handleSaveDraft = (e) => {
    e.preventDefault();
    if (!allRequiredFilled()) {
      alert("Por favor, completa todos los campos requeridos antes de guardar.");
      return;
    }
    const newJob = createJobObject("Borrador");
    saveJob(newJob);
  };

  const handlePublish = (e) => {
    e.preventDefault();
    if (!allRequiredFilled()) {
      alert("Por favor, completa todos los campos requeridos antes de publicar.");
      return;
    }
    const newJob = createJobObject("Publicado");
    saveJob(newJob);
  };

  const saveJob = (jobObj) => {
    const storedJobs = JSON.parse(localStorage.getItem("jobs")) || [];
    localStorage.setItem("jobs", JSON.stringify([...storedJobs, jobObj]));
    alert(`¡Empleo guardado con estado: ${jobObj.status}!`);
    navigate("/mi-cuenta/empleos-publicados");
  };

  return (
    <div className="register-container">
      <div className="register-card">
        {/* Botón para regresar a Mi Cuenta */}
        <button className="back-button" onClick={() => navigate("/mi-cuenta")}>
          <FaArrowLeft className="back-icon" /> Regresar a Mi Cuenta
        </button>

        <h2 className="register-title">Publica tu Empleo</h2>
        <form className="register-form">
          {/* Título */}
          <div className="form-group">
            <label>
              Título del Trabajo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Ej: Desarrollador Frontend"
                required
              />
            </div>
          </div>

          {/* Categoría */}
          <div className="form-group">
            <label>
              Categoría <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={category}
                onChange={handleCategoryChange}
                required
              >
                <option value="">Selecciona</option>
                {Object.keys(categories).map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Subcategoría */}
          <div className="form-group">
            <label>
              Subcategoría <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={subcategory}
                onChange={(e) => setSubcategory(e.target.value)}
                required
                disabled={!category}
              >
                <option value="">Selecciona</option>
                {category &&
                  categories[category].map((subcat) => (
                    <option key={subcat} value={subcat}>
                      {subcat}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          {/* Descripción */}
          <div className="form-group">
            <label>
              Descripción del Puesto <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <textarea
                className="form-control"
                rows="4"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Describe el rol, responsabilidades, etc."
                required
              />
            </div>
          </div>

          {/* Requisitos */}
          <div className="form-group">
            <label>
              Requisitos del Empleo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <textarea
                className="form-control"
                rows="3"
                value={requirements}
                onChange={(e) => setRequirements(e.target.value)}
                placeholder="Ej: 2+ años de experiencia, conocimientos específicos..."
                required
              />
            </div>
          </div>

          {/* Beneficios */}
          <div className="form-group">
            <label>
              Beneficios del Empleo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <textarea
                className="form-control"
                rows="2"
                value={benefits}
                onChange={(e) => setBenefits(e.target.value)}
                placeholder="Ej: Seguro médico, bonos, horario flexible..."
                required
              />
            </div>
          </div>

          {/* Estado (EE.UU.) */}
          <div className="form-group">
            <label>
              Estado (EE.UU.) <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={stateUS}
                onChange={(e) => setStateUS(e.target.value)}
                required
              >
                <option value="">Selecciona</option>
                {statesUS.map((st) => (
                  <option key={st} value={st}>
                    {st}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Ciudad */}
          <div className="form-group">
            <label>
              Ciudad <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <input
                type="text"
                className="form-control"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                placeholder="Ingresa la ciudad"
                required
              />
            </div>
          </div>

          {/* Código Postal */}
          <div className="form-group">
            <label>
              Zip Code <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <input
                type="text"
                className="form-control"
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
                placeholder="Ej: 33101"
                required
              />
            </div>
          </div>

          {/* Modalidad */}
          <div className="form-group">
            <label>
              Modalidad de Trabajo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={modality}
                onChange={(e) => setModality(e.target.value)}
                required
              >
                <option value="">Selecciona</option>
                <option value="Remoto">Remoto</option>
                <option value="On-Site">On-Site</option>
                <option value="Semi-remoto">Semi-remoto</option>
              </select>
            </div>
          </div>

          {/* Idioma del Trabajo */}
          <div className="form-group">
            <label>
              Idioma del Trabajo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={workLanguage}
                onChange={(e) => setWorkLanguage(e.target.value)}
                required
              >
                <option value="">Selecciona</option>
                <option value="Español">Español</option>
                <option value="Inglés">Inglés</option>
                <option value="Ambos">Ambos</option>
              </select>
            </div>
          </div>

          {/* Requisito de Visa */}
          <div className="form-group">
            <label>
              Requisito de Visa <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={visaRequirement}
                onChange={(e) => setVisaRequirement(e.target.value)}
                required
              >
                <option value="">Selecciona</option>
                <option value="Visa requerida">Visa requerida</option>
                <option value="Patrocinio disponible">Patrocinio disponible</option>
              </select>
            </div>
          </div>

          {/* Tipo de Trabajo */}
          <div className="form-group">
            <label>
              Tipo de Trabajo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={jobType}
                onChange={(e) => setJobType(e.target.value)}
                required
              >
                <option value="">Selecciona</option>
                <option value="Tiempo completo">Tiempo completo</option>
                <option value="Medio tiempo">Medio tiempo</option>
                <option value="Freelance">Freelance</option>
                <option value="Contrato">Contrato</option>
              </select>
            </div>
          </div>

          {/* Salario */}
          <div className="form-group">
            <label>
              Salario <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <input
                type="text"
                className="form-control"
                value={salary}
                onChange={(e) => setSalary(e.target.value)}
                placeholder="Ej: USD 2000 - 2500 / mes"
                required
              />
            </div>
          </div>

          {/* Opcionales: Teléfono y Email de Contacto */}
          <div className="form-group">
            <label>Teléfono de Contacto (opcional)</label>
            <div className="input-wrapper">
              <input
                type="tel"
                className="form-control"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Ej: +1 (305) 123-4567"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Correo de Contacto (opcional)</label>
            <div className="input-wrapper">
              <input
                type="email"
                className="form-control"
                value={contactEmail}
                onChange={(e) => setContactEmail(e.target.value)}
                placeholder="Ej: empresa@example.com"
              />
            </div>
          </div>

          {/* Botones de acción */}
          <div className="form-buttons">
            <button className="draft-button" onClick={handleSaveDraft}>
              Guardar como Borrador
            </button>
            <button className="submit-button" onClick={handlePublish}>
              Publicar Empleo
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PublicarEmpleo;